import { isEqual } from 'lodash';

/**
 * The tasks of a background ``llm_usecases`` *snapshot*, merged into *current*
 * (the tasks now): a field that changed since the request began, compared with
 * *atRequest*, keeps its current value, because a live update or an edit made
 * while the request was pending is newer than the snapshot. Every other field,
 * and the list of tasks itself, comes from the snapshot.
 */
export function mergeUsecasesSnapshot(snapshot, atRequest, current) {
    const before = new Map((atRequest || []).map((usecase) => [usecase._id, usecase]));
    const now = new Map((current || []).map((usecase) => [usecase._id, usecase]));
    return snapshot.map((fresh) => {
        const was = before.get(fresh._id);
        const is = now.get(fresh._id);
        if (!was || !is || was === is) return fresh;
        const changed = Object.keys(is).filter((key) => !isEqual(is[key], was[key]));
        if (!changed.length) return fresh;
        return { ...fresh, ...Object.fromEntries(changed.map((key) => [key, is[key]])) };
    });
}
